import styled from "styled-components";

export const Container = styled.div`
  padding-bottom: 10rem;

  height: calc(100vh - 8.4rem);
  overflow-y: auto;
  overflow-x: hidden;
`;
export const Styles = styled.div`
  gap: 5.4rem;
  h2 {
    font-size: 2.6rem;

    text-transform: capitalize;
  }
`;

export const TextStyles = styled.div`
  gap: 3rem;
  display: flex;
  flex-direction: column;
`;

export const LogoStyle = styled.div`
  h2 {
    font-size: 2.4rem;
    text-transform: capitalize;
    margin-bottom: 3rem;
  }
  h3 {
    font-size: 1.8rem;
    text-transform: capitalize;
    margin-bottom: 3rem;
  }
`;

export const LogoStyleList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: center;
  gap: 2rem;
`;

export const LogoSize = styled.div`
  margin-top: 3.2rem;
  cursor: pointer;

  .size {
    padding: 1.2rem 3.2rem;
    border: 1px solid #d97706;
    transition: all 300ms ease-in-out;
    font-size: 1.2rem;
    text-transform: capitalize;
    font-weight: bold;
  }

  .size:hover,
  .size.selected {
    border-color: transparent;
    background-color: #d97706;
  }
`;

export const SelectProductWrapper = styled.div`
  cursor: pointer;

  overflow-y: hidden;

  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  margin-bottom: 3rem;
  span.preview {
    font-size: 1.6rem;
    text-align: center;
    display: inline-block;
    font-weight: bold;
  }
`;

export const SelectedProductPreview = styled.div`
  height: 25rem;
  width: 100%;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  border: 2px solid #d97706;
  border-radius: 15px;
`;

export const FontSizeSliderWrapper = styled.div`
  label {
    font-size: 1.4rem;
    margin-bottom: 0.8rem;
  }
`;

export const FontSizeSlider = styled.input`
  cursor: pointer;
  color: #d97706;
  accent-color: #d97706;
  --webkit-accent-color: #d97706;
`;

export const SelectProductMessage = styled.span`
  font-size: 1.4rem;
  text-align: center;
  display: inline;
  border-bottom: 1px solid #d97706;
`;
